import { useNavigationData } from './useNavigationData';

export const isExternalLink = (url: string): boolean => {
	const { navigationData } = useNavigationData();
	const parsedNavigationData = JSON.stringify(navigationData);

	return !parsedNavigationData.includes(url);
};
